/**
 * Sentence-level diff for the problem representation. A statement rewrites
 * after each reveal; the sentences the new step added are the ones not
 * present verbatim in the previous statement.
 */

// Boundaries: a terminal mark, whitespace, then a capital or a digit. A
// decimal ("37.8", "2.8 percent") has no whitespace after the point, so it
// never splits. The whitespace is kept with the preceding sentence so the
// pieces re-join to the original text.
export function splitSentences(text) {
  const t = text || '';
  const out = [];
  let start = 0;
  const re = /[.!?]+\s+(?=[A-Z0-9])/g;
  let m;
  while ((m = re.exec(t)) !== null) {
    out.push(t.slice(start, m.index + m[0].length));
    start = m.index + m[0].length;
  }
  if (start < t.length) out.push(t.slice(start));
  return out;
}

/** Indices of the sentences in `next` that `prev` does not contain verbatim. */
export function freshSentences(prev, next) {
  const seen = new Set(splitSentences(prev).map((s) => s.trim()));
  return splitSentences(next)
    .map((s, i) => (seen.has(s.trim()) ? null : i))
    .filter((i) => i !== null);
}
